// src/utils/bookingSource.js
//
// Pass 82C — tenant-neutral canonical MANUAL booking source. "manual" describes HOW a record entered Motus (a human
// typed it in), NOT which organization owns it — so the generic manual-booking writer must not stamp SAS semantics.
// The legacy value `manual_sas` (stamped by createManualBooking before Pass 82C) stays READABLE via the compatibility
// helper below; no historical record is rewritten. SAS-imported records keep their own external sources
// (sas_master_schedule / sas_schedule_grid / sas_collective_schedule) — those are source adapters, not "manual".
export const MANUAL_BOOKING_SOURCE = 'manual';

// Historical + canonical manual markers. `manual_sas` = the pre-82C generic-writer value (now compatibility-only).
const MANUAL_SOURCE_ALIASES = new Set(['manual', 'manual_sas']);

export function isManualBookingSource(source) {
  return MANUAL_SOURCE_ALIASES.has(String(source == null ? '' : source));
}

// Collapse any manual marker to the canonical 'manual' for analytics/display; leave non-manual sources untouched.
export function normalizeBookingSource(source) {
  return isManualBookingSource(source) ? MANUAL_BOOKING_SOURCE : String(source == null ? '' : source);
}
